import { getCookie } from 'common/Cookie';
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

type PrivateRouteProps = {
  component: React.ComponentType;
  requiredRole?: string; // 필요 권한을 인자로 받음, 기본값은 없음
};

// JWT payload의 구조
type DecodedToken = {
  Objectname: string;
  profilePic: string;
  roles: string[];
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, requiredRole }) => {
  const accessToken = getCookie('accessToken');
  const navigate = useNavigate();

// 토큰이 없는 경우 로그인 페이지로 리다이렉트
if (!accessToken) {
  return <Navigate to="/login" replace />;
}

try {
  // JWT 토큰 디코딩
  const decoded: DecodedToken = jwtDecode(accessToken);
  console.log('decoded.roles', decoded.roles);

  // 필요 권한이 있는지 확인
  if (requiredRole && (!decoded.roles || !decoded.roles.includes(requiredRole))) {
    return <Navigate to="/error?code=403" replace />;
  }

  // 권한이 있으면 정상적으로 컴포넌트 렌더링
  return <Component />;
} catch (error) {
  console.error("Token decoding failed:", error);
  return <Navigate to="/login" replace />;
}
};

export default PrivateRoute;
